import { ExternalLinkButton } from "@/components/blocks/ExternalLinkButton";
import { ProductShot } from "@/components/blocks/ProductShot";
import {
	EditorScene,
	TrackingScene,
} from "@/components/blocks/scenes/QuestoveryScreens";
import { QuestScene } from "@/components/blocks/scenes/QuestScene";
import { CardGrid, toCardItems } from "@/components/blocks/sections/CardGrid";
import { Cta } from "@/components/blocks/sections/Cta";
import { Facts } from "@/components/blocks/sections/Facts";
import { PageHero } from "@/components/blocks/sections/PageHero";
import { Section } from "@/components/blocks/sections/Section";
import { CaseBlock } from "@/components/blocks/work/CaseBlock";
import { Reveal } from "@/components/motion/motion";
import { QUESTOVERY_URL } from "@/lib/constants";
import { useI18n } from "@/lib/i18n/use-i18n";

const CTA_ID = "contact";

export function QuestoveryCasePage() {
	const { dict } = useI18n();
	const page = dict.questoveryCase;
	const shots = page.solution.shots;

	return (
		<>
			<PageHero
				label={page.hero.label}
				title={page.hero.title}
				emphasis={page.hero.emphasis}
				intro={page.hero.intro}
				footer={
					<div className="mx-auto w-full max-w-7xl px-6 pb-16 lg:px-10">
						<Facts items={page.facts} />
					</div>
				}
			>
				<ExternalLinkButton
					href={QUESTOVERY_URL}
					cta="questovery"
					placement="case_hero"
					variant="outline"
				>
					{page.productLink}
				</ExternalLinkButton>
			</PageHero>

			<Section containerClassName="space-y-14">
				<CaseBlock index="01" title={page.situation.title}>
					<p>{page.situation.body}</p>
				</CaseBlock>
				<CaseBlock index="02" title={page.intervention.title}>
					<p>{page.intervention.body}</p>
				</CaseBlock>
				<CaseBlock index="03" title={page.solution.title}>
					<p>{page.solution.body}</p>
				</CaseBlock>
				<CardGrid items={toCardItems(page.solution.items)} numbered />
			</Section>

			<Section tone="stone">
				<div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
					<Reveal>
						<ProductShot
							alt={shots.editor}
							caption={shots.editor}
							fallback={<EditorScene />}
						/>
					</Reveal>
					<Reveal delay={0.1}>
						<ProductShot
							format="phone"
							alt={shots.mobile}
							caption={shots.mobile}
							fallback={<QuestScene ranking={false} />}
						/>
					</Reveal>
				</div>
				<Reveal className="mx-auto mt-14 max-w-4xl">
					<ProductShot
						alt={shots.tracking}
						caption={shots.tracking}
						fallback={<TrackingScene />}
					/>
				</Reveal>
			</Section>

			<Section containerClassName="space-y-14">
				<CaseBlock index="04" title={page.usage.title}>
					<p>{page.usage.body}</p>
					<p className="rounded-2xl border-l-2 border-signal bg-muted/60 p-5 text-base">
						{page.usage.note}
					</p>
				</CaseBlock>
				<CaseBlock index="05" title={page.next.title}>
					<p>{page.next.body}</p>
				</CaseBlock>
			</Section>

			<Cta id={CTA_ID} {...page.cta} placement="case_cta" />
		</>
	);
}
